import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import {
  MEDIA_QUERY_SMALL_SCREEN,
} from 'client/constants/mediaQueries';

import {
  getLeaseTemplates,
} from 'common/leaseDrafting/leaseTemplates';

import {
  createFormFieldsByIdGetter,
} from 'client/helpers/formikHelpers';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrCard from 'client/components/SrCard/SrCard';
import SrFormikField, {
  SR_FIELD_THEME_ADOBE,
} from 'client/components/SrFormikField';

import SrPartnerApprovalContext from './SrPartnerApprovalContext';
import SrPartnerApprovalAddendaCheckbox from './SrPartnerApprovalAddendaCheckbox';

const SrPartnerApprovalFormStepAddenda = ({
  formikBag,
  formFields,
}) => {
  const {
    householdApplications,
    householdGuarantors,
    householdListing,
    listing,
  } = useContext(SrPartnerApprovalContext);
  const [showAllDocuments, setShowAllDocuments] = useState(false);
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const leaseTemplates = getLeaseTemplates({
    applications: householdApplications,
    guarantors: householdGuarantors,
    householdListing,
    listing: listing,
  }).filter(({ enabled }) => enabled);
  const getFormFieldsById = createFormFieldsByIdGetter(formFields);
  const additionalAddendaFormField = getFormFieldsById('additionalAddenda');

  return (
    <SrCard>
      <SrText
        font='greycliff'
        weight='800'
        size='21'
        lineHeight='25px'
      >
        Required:
      </SrText>
      <SrBox height='5px' />
      <SrText
        font='greycliff'
        weight='700'
        color='grey400'
        display='block'
        size='16'
        lineHeight='25px'
      >
        Based on the information we’ve gathered for this
        listing we’re showing the required addenda for the lease.
      </SrText>
      <SrBox height='11px' />
      {leaseTemplates.map((template) => {
        return (
          <SrBox key={template.title} marginBottom='8px'>
            <SrPartnerApprovalAddendaCheckbox />
            <SrText
              font='greycliff'
              weight='800'
              size='18'
              lineHeight='20px'
              paddingLeft='8px'
            >
              {template.title}
            </SrText>
          </SrBox>
        );
      })}
      <SrBox height='32px' />
      <SrText
        font='greycliff'
        weight='800'
        size='21'
        lineHeight='25px'
      >
        Select additional Addenda:
      </SrText>
      <SrBox height='5px' />
      <SrText
        font='greycliff'
        weight='700'
        color='grey400'
        display='block'
        size='16'
        lineHeight='25px'
      >
        Choose any additional addenda you’d like us to include while drafting the lease.
      </SrText>
      <SrBox height='11px' />
      <SrFormikField
        formField={{
          ...additionalAddendaFormField,
          properties: {
            ...additionalAddendaFormField.properties,
            choices: (showAllDocuments || !isSmallScreen)
              ? additionalAddendaFormField.properties.choices
              : additionalAddendaFormField.properties.choices.filter((x, i) => i < 3),
          },
        }}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      {isSmallScreen && (
        <SrBox textAlign='center' margin='24px 0'>
          <SrText
            color='blue300'
            weight='600'
            cursor='pointer'
            onClick={() => setShowAllDocuments(!showAllDocuments)}
          >
            {showAllDocuments ? 'Show Less' : 'Show More'}
          </SrText>
        </SrBox>
      )}
    </SrCard>
  );
};

SrPartnerApprovalFormStepAddenda.propTypes = {
  formikBag: PropTypes.object.isRequired,
  formFields: PropTypes.array.isRequired,
};

SrPartnerApprovalFormStepAddenda.displayName = 'SrPartnerApprovalFormStepAddenda';

export default SrPartnerApprovalFormStepAddenda;
